// Assainit un fragment HTML avant rendu via dangerouslySetInnerHTML (anti-XSS stockée).
import DOMPurify from 'dompurify';

export const cleanHtml = (html) => DOMPurify.sanitize(html == null ? '' : String(html));

export default cleanHtml;
